(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('RecoverController', RecoverController);

    RecoverController.$inject = ['$scope', '$locale', '$uibModalInstance', 'UserService', 'LoginService'];

    function RecoverController($scope, $locale, $uibModalInstance, UserService, LoginService) {
        var vm = this;

        vm.email = '';
        vm.requestRunning = false;

        vm.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.recover = function () {
            if (vm.recoverPassword.$valid) {
                var data = {
                    email: vm.email,
                    language: $locale.id
                };
                vm.requestRunning = true;
                UserService.recoverPassword(data).then(sucessRecover).catch(errorRecover);
            }
        }

        function sucessRecover() {
            vm.requestRunning = false;
            LoginService.successModalConstructor('recoverPassword');
        }

        function errorRecover(response) {
            vm.requestRunning = false;
            LoginService.errorModalConstructor(response, 'recoverPassword');
        }
    }
})();